/*
 * File: c:\Users\l.haddad\Desktop\MOBYBUY\mobybuy_backoffice\src\Content\Modals\ModalCollection\ModalCollection.tsx
 * Project: c:\Users\l.haddad\Desktop\MOBYBUY\mobybuy_backoffice
 * Created Date: Monday July 21st 2025
 * Author: Tommy Boisseau
 * -----
 * Last Modified: Monday July 21st 2025 11:55:07 am
 * Modified By: the developer formerly known as Tommy Boisseau at <t.boisseau@autobuy.fr>
 * -----
 * Copyright (c) 2025 Autobuy SAS
 * -----
 */

import { FormEvent, Fragment, MouseEventHandler, useState } from "react";
import MyModal from "Content/Modals/MyModal";
import {Form, Button} from "react-bootstrap";
import translator from "MultiLanguage/TranslationWrapper";
import Styles from "Content/Modals/ModalCollection/ModalCollection.module.css";
import LoadingScreen from "Content/LoadingScreen/LoadingScreen";
import ModalConfirmation from "Content/Modals/ModalConfirmation/ModalConfirmation";
import { TextField } from "@mui/material";
import CollectionService from "Services/Visuals/Collection/CollectionService";

type ModalProps = {
    show: boolean;
    onClose: MouseEventHandler<HTMLDivElement>;
    closeModal: MouseEventHandler;
    title: string;
    onCollectionCreated?: () => void;
};

function ModalCollection(props: ModalProps) {
    const [name, setName] = useState<string | null>(null);
    const [spinner, setSpinner] = useState(false);
    const [isOkay, setIsOkay] = useState<boolean>(false);
    const [openModal, setOpenModal] = useState<boolean>(false);

    const HandleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsOkay(false);
        setSpinner(true);

        if (name) {
            CollectionService.createCollection(name).then(() => {
                setIsOkay(true);
                setOpenModal(true);
                setSpinner(false);
                props.onCollectionCreated?.();
            }).catch(() => {
                setIsOkay(false);
                setOpenModal(true);
                setSpinner(false);
            })
        }
        setName(null);
    };

    return(
        <Fragment>
            <MyModal closeModal={props.closeModal} show={props.show} addCloseCross={true} onClose={props.onClose} footer={(() => { return (<></>); })()} title={props.title} className={`${Styles.modal}`}>
                {
                    spinner ?
                        <div className={`${Styles.spinnerHolder}`}>
                            <LoadingScreen />
                        </div>
                        :null
                }
                <Form className={`${Styles.formHolder}`} onSubmit={HandleSubmit}>
                    <TextField label={translator.decode("dynamic.name")} onChange={(e) => setName(e.target.value)} value={name} />
                    <Button disabled={!name} className="mb-3" type="submit">{translator.decode("dynamic.create")}</Button>
                </Form>
            </MyModal>
            <ModalConfirmation show={openModal} onClose={(e) => { setOpenModal(false); props.closeModal(e) }} closeModal={(e) => { setOpenModal(false); props.closeModal(e) }} isOkay={isOkay} />
        </Fragment>
    )
}

export default ModalCollection;
